import moment from "moment";

export const getThisFinancialYear = (currency) => {
  const date = moment();
  const thisYear = date.year();
  const { localisedStartDate, localisedEndDate } = getLocalisedDates(currency, thisYear);
  return getFYDateRange(localisedStartDate, localisedEndDate, thisYear, date);
};

export const getLastFinancialYear = (currency) => {
  let { startDate, endDate } = getThisFinancialYear(currency);
  startDate = startDate.subtract(1, "years");
  endDate = endDate.subtract(1, "years");
  return { startDate, endDate };
};

const getLocalisedDates = (currency, thisYear) => {
  let localisedStartDate = moment().year(thisYear).month(6).startOf("month");
  let localisedEndDate = moment().year(thisYear).month(5).endOf("month");
  if (currency === "NZD") {
    localisedStartDate = moment().year(thisYear).month(3).startOf("month");
    localisedEndDate = moment().year(thisYear).month(2).endOf("month");
  }
  return { localisedStartDate, localisedEndDate };
};

const getFYDateRange = (localisedStartDate, localisedEndDate, thisYear, date) => {
  if (date.isAfter(localisedEndDate)) {
    return { startDate: localisedStartDate, endDate: localisedEndDate.year(thisYear + 1) };
  }
  return { startDate: localisedStartDate.year(thisYear - 1), endDate: localisedEndDate };
};



// WEBPACK FOOTER //
// ./src/js/utils/financial-year.js